import { IFITracker } from '../../../cimsPage/instances/ifi'
import { Revert, Simple } from '../../common'

const object = 'Identified Field Issue'
const page = IFITracker

export const ViewIdentifiedFieldIssue = Simple({
  id: 'd7528ff3-1eb3-45bf-869d-30a999d0afb4',
  action: 'View',
  object,
  page,
})

export const EditIdentifiedFieldIssue = Simple({
  id: '911deff5-d684-49f4-850d-a027964eb706',
  action: 'Edit',
  object,
  page,
})

export const ReviewIdentifiedFieldIssue = Simple({
  id: '7d5a4a28-851e-4735-97c7-20f9856b7460',
  action: 'Review',
  object,
  page,
})

export const RevertIdentifiedFieldIssue = Revert({
  id: 'c65a30c6-e5a5-421b-9f98-24dc5e8d6979',
  object,
  page,
})

export const CommentOnIdentifiedFieldIssue = Simple({
  id: '0626815e-8a23-4573-9c31-14cd50432e02',
  object,
  page,
  action: 'Comment on',
})

export type IFITrackerPermission =
  | typeof ViewIdentifiedFieldIssue
  | typeof EditIdentifiedFieldIssue
  | typeof ReviewIdentifiedFieldIssue
  | typeof RevertIdentifiedFieldIssue
  | typeof CommentOnIdentifiedFieldIssue
